module.exports = __webpack_public_path__ + "img/snowboarding3.f96cd566.jpg";